'use strict';

function GridNDReoptPreviewNotSendButtonDirective() {
  return {
    restrict: 'E',
    require: '^^rmGridToolbar',
    scope: true,
    template: require('../templates/grid-nd-reopt-preview-not-send-button.html'),
    controller: 'GridNdReoptPreviewNotSendButtonController',
    link: function link($scope) {
      $scope.$on('grid:rowSelectionChanged', $scope.onRowSelection);
    }
  };
}
GridNDReoptPreviewNotSendButtonDirective.$inject = [];
module.exports = GridNDReoptPreviewNotSendButtonDirective;